export const ACTIVITY_ID = 'activity';
export const ALLERGY_ID = 'allergies';
export const APPOINTMENTS_ID = 'appointments';
export const BODY_ID = 'body';
export const BODY_SCAN_ID = 'body-scan-history';
export const CONTACT_ID = 'contacts';
export const COUGH_SCAN_ID = 'cough-scan-history';
export const DIRECTIVES_ID = 'legal-directives';
export const EMERGENCY_VISIT_ID = 'emergency-visits';
export const EXTENDED_PROFILE_ID = 'extended-profile';
export const FACE_SCAN_ID = 'face-scan-history';
export const FAMILY_HISTORY_ID = 'family-history';
export const FITNESS_ID = 'fitness';
export const CARRIER_STATUS_ID = 'genetic-information-carrier-status';
export const HEALTH_RISK_ID = 'genetic-information-health-risk';
export const HOSPITALIZATION_ID = 'hospitalizations';
export const IMAGING_TESTS_ID = 'imaging-and-tests';
export const IMMUNIZATION_ID = 'immunizations';
export const INSURANCE_PROGRAMS = 'insurance-programs';
export const MEDICAL_CONDITION_ID = 'medical-conditions';
export const LAB_RESULTS_ID = 'labs';
export const MEDICATION_ID = 'medications';
export const PAYMENT_DISPLAY_SET_ID = 'payment';
export const QUESTIONNAIRE_DISPLAY_SET_ID = 'questionaiire';
export const SKIN_SCAN_ID = 'skin-scan-history';
export const SLEEP_ID = 'sleep';
export const SURGERY_ID = 'surgeries';
export const VITAL_SIGN_ID = 'vital-signs';

export const CONSENT_RECORDS_VITALL = 'consent-records-vitall';
export const CONSENT_RECORDS_COLLECTION = 'consent-records-collection';
export const CONSENT_RECORDS_PROCESSING = 'consent-records-processing';
export const CONSENT_RECORDS_FITNESS_HEALTH =
  'consent-records-fitness-and-health-devices';
export const CONSENT_CASL = 'consent-CASL';
export const CONSENT_REGISTRATION = 'consent-registration';
export const CONSENT_CAPTURE = 'consent-capture';

export const VITAL_SIGN_OXYGEN_SATURATION_ID = 'vital-sign---oxygen-saturation';
export const VITAL_SIGN_TEMPERATURE_ID = 'vital-sign---temperature';
export const VITAL_SIGN_PAIN_ID = 'vital-sign---pain';
export const VITAL_SIGN_RESPIRATION_ID = 'vital-sign---respiration';
export const VITAL_SIGN_BLOOD_PRESSURE_ID = 'vital-sign---blood-pressure';
export const VITAL_SIGN_HEART_RATE_ID = 'vital-sign---heart-rate';
export const VITAL_SIGN_BLOOD_SUGAR_ID = 'vital-sign---blood-sugar';
export const VITAL_SIGN_BODY_WEIGHT = 'vital-sign---weight';

export const LABS_PATHOLOGY_ID = 'labs_pathology';
export const LABS_OTHER_URINE_ANALYSES_ID = 'labs_other-urine-analyses';
export const LABS_MICROBIOLOGY_ID = 'labs_microbiology';
export const LABS_CBC_ID = 'labs_cbc';
export const LABS_LIPIDS_ID = 'labs_lipids';
export const LABS_URINANALYSES_ID = 'labs_urinalysis';
export const LABS_LIVER_FUNTION_ID = 'labs_liver-function';
export const LABS_CHEMISTRY_ID = 'labs_chemistry';
export const LABS_GENETICS_ID = 'labs_genetics';
export const LABS_OTHER_ID = 'labs_other';
export const LABS_THYROID_ID = 'labs_thyroid';
export const LABS_BLOOD_TRANSFUSION_ID = 'labs_blood-transfusion';
export const LABS_COAGULATION_ID = 'labs_coagulation';
export const LABS_CARDIAC_ID = 'labs_cardiac';
export const LABS_ELECTROLYTES_ID = 'labs_electrolytes';
export const LABS_ARTERIAL_BLOOD_GASES_ID = 'labs_arterial-blood-gases';

export const PROFILE_STATE_ID = 'profile-state';
export const ROUTINES_ID = 'routines';
export const RECORDS_UPDATE = 'records-update';
